/* Popup — trigger, frequency, accessibility, and AJAX submit for the
   email-capture modal in sections/popup.liquid. Vanilla, deferred.
   Fails safe: if storage is unavailable, the popup does not show. */
(function () {
  'use strict';

  /* Each popup section emits this script, so a page with two popups loads it
     twice — run the initialiser only once. */
  if (window.__eaglePopupInit) return;
  window.__eaglePopupInit = true;

  /* One page can carry more than one popup (e.g. a retail one and a
     wholesale one, each audience-gated), so every [data-popup] gets its own
     instance — a single querySelector would only ever wire the first. */
  function initPopup(root) {

  var dialog = root.querySelector('.popup__dialog');
  var form = root.querySelector('form');
  var formBody = root.querySelector('[data-form-body]');
  var success = root.querySelector('[data-success]');
  var errorEl = root.querySelector('[data-error]');
  var consent = root.querySelector('[data-consent]');
  var submitBtn = root.querySelector('[data-submit]');

  var cfg = {
    test: root.dataset.test === 'true',
    suppress: root.dataset.suppress === 'true',
    trigger: root.dataset.trigger,
    delay: parseInt(root.dataset.delay, 10) || 0,
    scroll: parseInt(root.dataset.scroll, 10) || 40,
    everyVisit: root.dataset.everyVisit === 'true',
    skipSubscribers: root.dataset.skipSubscribers !== 'false',
    dismissDays: parseInt(root.dataset.dismissDays, 10) || 14,
    submitDays: parseInt(root.dataset.submitDays, 10) || 365,
    repeat: parseInt(root.dataset.repeat, 10) || 0,
    autoClose: parseInt(root.dataset.autoclose, 10) || 0
  };

  var NS = root.id ? '_' + root.id.replace(/[^a-z0-9]+/gi, '') : '';
  var K_SUBMIT = 'eagle_popup_submitted' + NS;
  var K_DISMISS = 'eagle_popup_dismiss_until' + NS;
  var K_SHOWN = 'eagle_popup_shown_session' + NS;
  var K_VIEWS = 'eagle_popup_views' + NS;

  /* ---- storage (localStorage + cookie fallback); returns null if none ---- */
  var store = (function () {
    try {
      var t = '__eagle_test__';
      localStorage.setItem(t, '1');
      localStorage.removeItem(t);
      return {
        get: function (k) { return localStorage.getItem(k); },
        set: function (k, v) { localStorage.setItem(k, v); }
      };
    } catch (e) {
      if (!navigator.cookieEnabled) return null;
      return {
        get: function (k) {
          var m = document.cookie.match('(^|;)\\s*' + k + '\\s*=\\s*([^;]+)');
          return m ? decodeURIComponent(m.pop()) : null;
        },
        set: function (k, v) {
          document.cookie = k + '=' + encodeURIComponent(v) + ';path=/;max-age=' + (400 * 86400);
        }
      };
    }
  })();

  var sessionOk = (function () {
    try { sessionStorage.setItem('__e__', '1'); sessionStorage.removeItem('__e__'); return true; }
    catch (e) { return false; }
  })();

  function setSubmitted() { if (store) store.set(K_SUBMIT, String(Date.now() + cfg.submitDays * 86400000)); }
  function setDismissed() {
    if (!store) return;
    /* recurring mode uses a short minute-based window so it reappears */
    var ms = cfg.repeat > 0 ? cfg.repeat * 60000 : cfg.dismissDays * 86400000;
    store.set(K_DISMISS, String(Date.now() + ms));
  }
  function isSubmitted() {
    if (!store) return false;
    var s = store.get(K_SUBMIT);
    return !!(s && Date.now() < parseInt(s, 10));
  }

  /* ---- eligibility ---- */
  function eligible() {
    if (cfg.suppress) return false;              // cart / already-tagged customer
    if (cfg.test) return true;                    // preview: ignore all cookies
    if (!store || !sessionOk) return false;       // fail safe

    /* An announcement popup (Hide from existing subscribers = off) has no reason
       to stop for someone who once submitted the form — mirrors the server-side
       tag rule so both sides agree. */
    if (cfg.skipSubscribers && isSubmitted()) return false;

    /* "every visit" drops the frequency caps: it should fire on each page load
       that matches the trigger, not once per session or once per dismissal. */
    if (cfg.everyVisit) return true;

    var dis = store.get(K_DISMISS);
    if (dis && Date.now() < parseInt(dis, 10)) return false;
    /* once-per-session only applies when NOT in recurring mode */
    if (cfg.repeat === 0 && sessionStorage.getItem(K_SHOWN)) return false;
    return true;
  }

  /* ---- focus trap ---- */
  var lastFocused = null;
  function focusables() {
    return dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])');
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var opened = false;
  var repeatTimer;
  function open() {
    if (opened) return;
    opened = true;
    /* test mode must not write state either, or turning it off leaves the
       popup suppressed for the tester for dismissDays. */
    if (!cfg.test && !cfg.everyVisit && cfg.repeat === 0 && sessionOk) sessionStorage.setItem(K_SHOWN, '1');

    lastFocused = document.activeElement;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';

    root.classList.add('is-active');
    requestAnimationFrame(function () { root.classList.add('is-visible'); });

    var target = (formBody && !formBody.hidden) ? (root.querySelector('.popup__input') || dialog) : dialog;
    (target || dialog).focus({ preventScroll: true });
    document.addEventListener('keydown', onKeydown);
  }

  function close(dismiss) {
    if (!opened) return;
    opened = false;
    if (dismiss && !cfg.test && !cfg.everyVisit) setDismissed();
    root.classList.remove('is-visible');
    document.removeEventListener('keydown', onKeydown);
    var done = function () {
      root.classList.remove('is-active');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    };
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) done();
    else setTimeout(done, 260);

    /* recurring mode: bring it back after the interval (same page view),
       unless the visitor has since signed up */
    if (dismiss && cfg.repeat > 0 && !isSubmitted()) {
      clearTimeout(repeatTimer);
      repeatTimer = setTimeout(function () {
        if (isSubmitted() || cfg.suppress) return;
        fired = false;
        open();
      }, cfg.repeat * 60000);
    }
  }

  /* make the dialog focusable */
  dialog.setAttribute('tabindex', '-1');

  /* close triggers */
  root.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      close(true);
    });
  });

  /* consent gating */
  if (consent && submitBtn) {
    submitBtn.disabled = !consent.checked;
    consent.addEventListener('change', function () { submitBtn.disabled = !consent.checked; });
  }

  /* ---- submit (AJAX, in-place success) ---- */
  function showSuccess() {
    if (formBody) formBody.hidden = true;
    if (success) success.hidden = false;
    setSubmitted();
    if (cfg.autoClose > 0) setTimeout(function () { close(false); }, cfg.autoClose * 1000);
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) return;
      e.preventDefault();
      if (submitBtn.hasAttribute('data-loading')) return;
      var label = submitBtn.textContent;
      submitBtn.setAttribute('data-loading', '');
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = 'Sending…';
      if (errorEl) errorEl.hidden = true;

      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var posted = doc.querySelector('[data-posted]');
          var srvErr = doc.querySelector('[data-error-server]');
          if (posted || !srvErr) {
            showSuccess();
          } else {
            submitBtn.removeAttribute('data-loading');
            submitBtn.removeAttribute('aria-busy');
            submitBtn.textContent = label;
            if (errorEl) { errorEl.textContent = srvErr.textContent.trim(); errorEl.hidden = false; }
          }
        })
        .catch(function () {
          submitBtn.removeAttribute('data-loading');
          submitBtn.removeAttribute('aria-busy');
          submitBtn.textContent = label;
          if (errorEl) { errorEl.textContent = 'Something went wrong — please try again.'; errorEl.hidden = false; }
        });
    });
  }

  /* copy code */
  var copyBtn = root.querySelector('[data-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = (root.querySelector('[data-code-value]') || {}).textContent || '';
      var done = function () { var t = copyBtn.textContent; copyBtn.textContent = 'Copied!'; setTimeout(function () { copyBtn.textContent = t; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(code.trim()).then(done).catch(done);
      else done();
    });
  }

  /* ---- arm the trigger ---- */
  if (!eligible()) return;

  var fired = false;
  function fire() { if (fired) return; fired = true; teardown(); open(); }
  var scrollHandler, mouseHandler, timer;

  function teardown() {
    if (scrollHandler) window.removeEventListener('scroll', scrollHandler);
    if (mouseHandler) document.removeEventListener('mouseout', mouseHandler);
    if (timer) clearTimeout(timer);
  }

  var isTouch = window.matchMedia('(hover: none)').matches;

  /* test mode: show quickly regardless of trigger so it's easy to preview
     on any device (desktop or mobile) */
  if (cfg.test) {
    timer = setTimeout(fire, 1000);
    return;
  }

  switch (cfg.trigger) {
    case 'scroll':
      scrollHandler = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && (window.scrollY / h) * 100 >= cfg.scroll) fire();
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
      break;
    case 'exit':
      if (isTouch) { timer = setTimeout(fire, 30000); break; } // no exit intent on touch — soft fallback
      mouseHandler = function (e) { if (e.clientY <= 0) fire(); };
      document.addEventListener('mouseout', mouseHandler);
      break;
    case 'second':
      var views = 1;
      if (sessionOk) {
        views = (parseInt(sessionStorage.getItem(K_VIEWS), 10) || 0) + 1;
        sessionStorage.setItem(K_VIEWS, String(views));
      }
      if (views >= 2) timer = setTimeout(fire, 1200);
      break;
    default: // time
      timer = setTimeout(fire, Math.max(0, cfg.delay) * 1000);
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-popup]');
    for (var i = 0; i < nodes.length; i++) initPopup(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
